(function() {
    'use strict';
    
    window.shrine = window.shrine || {};
    
    
    shrine.config = {
      animations: document.documentElement.dataset.animationsType || 'default',
      countryList: document.querySelector('[data-country-list]')?.dataset.countryList || '',
      countryListFunction: document.querySelector('[data-country-list-function]')?.dataset.countryListFunction || '',
      countryListError: document.querySelector('[data-country-list-error]')?.dataset.countryListError || ''
    };
    
    
    shrine.utils = {
      debounce: function(func, wait, immediate) {
        let timeout;
        return function() {
          const context = this, args = arguments;
          const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          const callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      },
      
      throttle: function(func, limit) {
        let inThrottle;
        return function() {
          const args = arguments;
          const context = this;
          if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
          }
        };
      },
      
      onKeyUpEscape: function(event) {
        if (event.code?.toUpperCase() === 'ESCAPE' || event.key === 'Escape' || event.keyCode === 27) {
          const target = event.target;
          const openDetails = target.closest('details[open]');
          if (openDetails) {
            openDetails.removeAttribute('open');
          }
          const openModals = document.querySelectorAll('.modal[open], details[open]');
          openModals.forEach(modal => {
            modal.removeAttribute('open');
          });
        }
      },
      
      fetchConfig: function(type = 'json') {
        return {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': `application/${type}`
          }
        };
      }
    };
    
    
    shrine.a11y = {
      trapFocus: function(container, elementToFocus) {
        const focusableElements = container.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];
        
        container._focusTrap = function(e) {
          if (e.key === 'Tab' || e.keyCode === 9) {
            if (e.shiftKey) {
              if (document.activeElement === firstFocusable) {
                lastFocusable.focus();
                e.preventDefault();
              }
            } else {
              if (document.activeElement === lastFocusable) {
                firstFocusable.focus();
                e.preventDefault();
              }
            }
          }
          
          if (e.key === 'Escape' || e.keyCode === 27) {
            const closeBtn = container.querySelector('[aria-label*="lose"]');
            if (closeBtn) closeBtn.click();
          }
        };
        
        container.addEventListener('keydown', container._focusTrap);
        
        if (elementToFocus) {
          elementToFocus.focus();
        } else if (firstFocusable) {
          firstFocusable.focus();
        }
      },
      
      removeTrapFocus: function(container, elementToFocus) {
        if (container && container._focusTrap) {
          container.removeEventListener('keydown', container._focusTrap);
        }
        if (elementToFocus) {
          elementToFocus.focus();
        }
      },
      
      pauseAllMedia: function() {
        document.querySelectorAll('video, audio').forEach(media => {
          media.pause();
        });
      }
    };
    
    window.debounce = shrine.utils.debounce;
    window.throttle = shrine.utils.throttle;
    window.onKeyUpEscape = shrine.utils.onKeyUpEscape;
    window.fetchConfig = shrine.utils.fetchConfig;
    window.trapFocus = shrine.a11y.trapFocus;
    window.removeTrapFocus = shrine.a11y.removeTrapFocus;
    window.pauseAllMedia = shrine.a11y.pauseAllMedia;
    
    // ============================================
    // Sincronización Quality → ReLasit Cod Form
    // ============================================
    shrine.quantityBreaksSync = {
      // Almacenar selecciones por producto
      savedSelections: new Map(),
      appliedToModal: new Map(),
      correctionAttempts: new Map(), // Contador de intentos de corrección por producto
      userInteracted: new Map(), // Bandera para detectar si el usuario ha interactuado manualmente
      isProgrammaticClick: false, // Bandera para distinguir clics programáticos de clics del usuario
      
      // Función helper para extraer cantidad del texto de la oferta
      extractQuantityFromText: function(text) {
        if (!text) return null;
        // Intentar múltiples patrones: "3x", "3 Unidad", "3 Unidades", o cualquier número
        let match = text.match(/(\d+)x/i); // Formato "3x"
        if (!match) {
          match = text.match(/(\d+)\s*Unidad/i); // Formato "3 Unidad" o "3 Unidades"
        }
        if (!match) {
          match = text.match(/(\d+)/); // Cualquier número en el texto
        }
        return match ? match[1] : null;
      },
      
      // Función para aplicar la selección guardada al modal de relasit
      // Aplica la selección de Quality cuando se abre el modal para evitar que ReLasit preseleccione siempre la oferta 3
      applySavedSelectionToRelasitModal: function(productId, savedQuantity, retryCount) {
        retryCount = retryCount || 0;
        const maxRetries = 15; // Aumentar intentos
        const key = productId || 'default';
        
        if (!savedQuantity) {
          return;
        }
        
        // Buscar el modal de relasit
        const relasitModal = document.querySelector('._rsi-modal-container');
        if (!relasitModal || window.getComputedStyle(relasitModal).display === 'none') {
          if (retryCount < maxRetries) {
            setTimeout(() => {
              this.applySavedSelectionToRelasitModal(productId, savedQuantity, retryCount + 1);
            }, 200);
          }
          return;
        }
        
        // Buscar las ofertas dentro del modal
        const relasitOffers = relasitModal.querySelectorAll('._rsi-quantity-offers-offer-container');
        if (relasitOffers.length === 0) {
          if (retryCount < maxRetries) {
            setTimeout(() => {
              this.applySavedSelectionToRelasitModal(productId, savedQuantity, retryCount + 1);
            }, 300);
          }
          return;
        }
        
        // Buscar la oferta que coincide con la cantidad guardada
        let targetOffer = null;
        for (let offer of relasitOffers) {
          const titleElement = offer.querySelector('._rsi-quantity-offers-title');
          if (titleElement) {
            const titleText = titleElement.textContent || '';
            const offerQuantity = this.extractQuantityFromText(titleText);
            if (offerQuantity && offerQuantity === savedQuantity.toString()) {
              targetOffer = offer;
              break;
            }
          }
        }
        
        if (!targetOffer) {
          return;
        }
        
        // Verificar si ya está seleccionada correctamente
        const isAlreadySelected = targetOffer.classList.contains('_rsi-quantity-offers-selected');
        let quantityInput = targetOffer.querySelector('input[name="item_quantity[qty_offer_0]"]');
        if (!quantityInput) {
          const variantsContainer = targetOffer.querySelector('._rsi-quantity-offers-variants');
          if (variantsContainer) {
            quantityInput = variantsContainer.querySelector('input[name="item_quantity[qty_offer_0]"]');
          }
        }
        
        if (isAlreadySelected && quantityInput && quantityInput.value === savedQuantity.toString()) {
          return; // Ya está correctamente seleccionada
        }
        
        // Deseleccionar TODAS las ofertas primero
        relasitOffers.forEach(offer => {
          offer.classList.remove('_rsi-quantity-offers-selected', 'selected', 'active', '_rsi-selected');
          offer.removeAttribute('data-selected');
          offer.removeAttribute('aria-selected');
          offer.style.removeProperty('border-color');
          offer.style.removeProperty('border');
          offer.style.removeProperty('border-width');
          offer.style.removeProperty('border-style');
          offer.style.removeProperty('background-color');
          offer.style.removeProperty('background');
          if (!offer.style.cssText || offer.style.cssText.trim() === '') {
            offer.removeAttribute('style');
          }
          
          // Desmarcar inputs dentro de otras ofertas
          const otherInputs = offer.querySelectorAll('input[type="radio"], input[type="checkbox"]');
          otherInputs.forEach(input => {
            input.checked = false;
          });
        });
        
        // Marcar como clic programático para evitar interferencias
        this.isProgrammaticClick = true;
        
        // Esperar un momento antes de hacer clic para asegurar que ReLasit haya terminado de cargar
        setTimeout(() => {
          // Hacer clic en la oferta correcta de múltiples formas para asegurar que funcione
          if (targetOffer.click && typeof targetOffer.click === 'function') {
            targetOffer.click();
          }
          
          // También disparar evento de clic
          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
            button: 0
          });
          targetOffer.dispatchEvent(clickEvent);
          
          // También intentar hacer clic en elementos internos clickeables
          const clickableElements = targetOffer.querySelectorAll('._rsi-quantity-offers-offer, button, a, [onclick]');
          clickableElements.forEach(el => {
            if (el.click && typeof el.click === 'function') {
              try {
                el.click();
              } catch(e) {
                // Ignorar errores
              }
            }
          });
          
          // Esperar a que ReLasit procese el clic y genere los inputs
          setTimeout(() => {
            // Buscar el input de cantidad dentro de la oferta seleccionada
            let quantityInput = targetOffer.querySelector('input[name="item_quantity[qty_offer_0]"]');
            if (!quantityInput) {
              const variantsContainer = targetOffer.querySelector('._rsi-quantity-offers-variants');
              if (variantsContainer) {
                quantityInput = variantsContainer.querySelector('input[name="item_quantity[qty_offer_0]"]');
              }
            }
            
            // También buscar en todo el modal por si ReLasit los coloca fuera
            if (!quantityInput) {
              const allInputs = relasitModal.querySelectorAll('input[name="item_quantity[qty_offer_0]"]');
              const offerPos = targetOffer.getAttribute('data-offer-pos');
              allInputs.forEach(input => {
                const inputOffer = input.closest('._rsi-quantity-offers-offer-container');
                if (inputOffer && inputOffer.getAttribute('data-offer-pos') === offerPos) {
                  quantityInput = input;
                }
              });
            }
            
            // Actualizar el input si existe
            if (quantityInput) {
              quantityInput.value = savedQuantity.toString();
              quantityInput.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
              quantityInput.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
            }
            
            // Asegurar que la oferta esté visualmente seleccionada
            targetOffer.classList.add('_rsi-quantity-offers-selected', 'selected', 'active', '_rsi-selected');
            targetOffer.setAttribute('data-selected', 'true');
            targetOffer.setAttribute('aria-selected', 'true');
            
            // Asegurar que otras ofertas NO estén seleccionadas
            relasitOffers.forEach(offer => {
              if (offer !== targetOffer) {
                offer.classList.remove('_rsi-quantity-offers-selected', 'selected', 'active', '_rsi-selected');
                offer.removeAttribute('data-selected');
                offer.removeAttribute('aria-selected');
                offer.style.removeProperty('border-color');
                offer.style.removeProperty('border');
                offer.style.removeProperty('background-color');
                offer.style.removeProperty('background');
                if (!offer.style.cssText || offer.style.cssText.trim() === '') {
                  offer.removeAttribute('style');
                }
              }
            });
            
            // Resetear la bandera después de un delay
            setTimeout(() => {
              this.isProgrammaticClick = false;
            }, 300);
          }, 500); // Aumentar delay para dar más tiempo a ReLasit
        }, 200); // Esperar antes de hacer clic
      },
      
      // Función para guardar la selección del quantity selector
      saveQuantitySelection: function(productId, selectedQuantity) {
        const key = productId || 'default';
        this.savedSelections.set(key, selectedQuantity);
        this.appliedToModal.set(key, false); // Resetear para permitir aplicar cuando se abra el modal
        
        // Guardar en localStorage también
        try {
          localStorage.setItem('relasit-selected-quantity', selectedQuantity);
          if (productId) {
            localStorage.setItem('relasit-product-id', productId);
          }
        } catch(e) {
          console.warn('No se pudo guardar en localStorage:', e);
        }
      },
      
      // Función para sincronizar con ReLasit Form
      // NOTA: Ya NO aplicamos selección automática desde Quality hacia ReLasit
      // Solo guardamos la selección para referencia, pero ReLasit maneja su propia selección
      syncWithRelasitForm: function(quantityBreaksElement, selectedQuantity) {
        // Obtener product ID del elemento o del contexto
        const sectionId = quantityBreaksElement.getAttribute('data-section') || '';
        const productId = this.getProductId(quantityBreaksElement);
        
        // Guardar la selección solo para referencia (no se aplicará automáticamente)
        this.saveQuantitySelection(productId, selectedQuantity);
        
        // Disparar evento personalizado
        const customEvent = new CustomEvent('quantity-break-selected', {
          detail: {
            quantity: selectedQuantity,
            sectionId: sectionId,
            productId: productId
          },
          bubbles: true
        });
        document.dispatchEvent(customEvent);
        
        // Actualizar atributos de datos
        quantityBreaksElement.setAttribute('data-selected-quantity', selectedQuantity);
        quantityBreaksElement.setAttribute('data-sync-timestamp', Date.now().toString());
        
        // NO aplicar selección automática - dejar que ReLasit maneje su propia selección
        // El usuario puede cambiar libremente en el formulario sin interferencia
      },
      
      // Obtener product ID del contexto
      getProductId: function(element) {
        // Primero intentar obtener del atributo data-product-id del elemento quantity-breaks
        if (element && element.getAttribute) {
          const productId = element.getAttribute('data-product-id');
          if (productId) {
            return productId;
          }
        }
        
        // Intentar obtener del formulario de producto
        const productForm = element ? element.closest('form[action*="/cart/add"]') : null;
        if (productForm) {
          const productSection = productForm.querySelector('[data-product-id]');
          if (productSection) {
            return productSection.getAttribute('data-product-id');
          }
        }
        
        // Intentar desde el script JSON de variantes
        const variantsScript = element ? element.querySelector('script[type="application/json"]') : null;
        if (variantsScript) {
          try {
            const variants = JSON.parse(variantsScript.textContent);
            if (variants && variants.length > 0 && variants[0].product_id) {
              return variants[0].product_id.toString();
            }
          } catch(e) {
            console.warn('No se pudo parsear variants JSON:', e);
          }
        }
        
        // Intentar desde localStorage
        try {
          return localStorage.getItem('relasit-product-id') || null;
        } catch(e) {
          return null;
        }
      },
      
      // Inicializar sincronización para un elemento quantity-breaks
      initQuantityBreaks: function(quantityBreaksElement) {
        if (!quantityBreaksElement) return;
        
        // Obtener todos los inputs radio de cantidad
        const quantityInputs = quantityBreaksElement.querySelectorAll('input[type="radio"][name="quantity"]');
        if (quantityInputs.length === 0) return;
        
        const productId = this.getProductId(quantityBreaksElement);
        const key = productId || 'default';
        
        // Agregar event listeners a cada input radio
        quantityInputs.forEach(input => {
          input.addEventListener('change', function() {
            if (this.checked) {
              const selectedQuantity = this.value;
              shrine.quantityBreaksSync.syncWithRelasitForm(quantityBreaksElement, selectedQuantity);
            }
          });
        });
        
        // Sincronizar al cargar la página si hay una selección previa
        const checkedInput = quantityBreaksElement.querySelector('input[type="radio"][name="quantity"]:checked');
        if (checkedInput) {
          // Cargar selección guardada si existe
          try {
            const savedQuantity = localStorage.getItem('relasit-selected-quantity');
            const savedProductId = localStorage.getItem('relasit-product-id');
            if (savedQuantity && (!savedProductId || savedProductId === productId)) {
              this.savedSelections.set(key, savedQuantity);
            }
          } catch(e) {
            console.warn('No se pudo leer localStorage:', e);
          }
          
          // Guardar la selección actual
          this.saveQuantitySelection(productId, checkedInput.value);
        }
        
        // Escuchar cambios desde relasit form hacia quantity-breaks (sincronización bidireccional)
        document.addEventListener('relasit-quantity-changed', function(e) {
          const relasitQuantity = e.detail?.quantity;
          if (relasitQuantity) {
            const matchingInput = quantityBreaksElement.querySelector(`input[type="radio"][name="quantity"][value="${relasitQuantity}"]`);
            if (matchingInput && !matchingInput.checked) {
              matchingInput.checked = true;
              matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      },
      
      // Inicializar todos los quantity-breaks en la página
      init: function() {
        // Buscar todos los elementos quantity-breaks
        const quantityBreaksElements = document.querySelectorAll('quantity-breaks[id^="quantity-breaks-"]');
        
        if (quantityBreaksElements.length === 0) {
          return;
        }
        
        quantityBreaksElements.forEach(element => {
          this.initQuantityBreaks(element);
        });
        
        // Observar cuando se abre el modal de relasit para aplicar la selección guardada de Quality
        let observerTimeout = null;
        let hasAppliedSelection = false; // Bandera para evitar múltiples aplicaciones
        
        const observer = new MutationObserver(function(mutations) {
          if (observerTimeout) {
            clearTimeout(observerTimeout);
          }
          
          observerTimeout = setTimeout(() => {
            const relasitModal = document.querySelector('._rsi-modal-container');
            if (relasitModal && window.getComputedStyle(relasitModal).display !== 'none') {
              // Resetear bandera cuando el modal se cierra
              if (relasitModal.style.display === 'none' || relasitModal.hasAttribute('aria-hidden')) {
                hasAppliedSelection = false;
                return;
              }
              
              // Solo aplicar una vez cuando se abre el modal
              if (!hasAppliedSelection) {
                const currentProductId = localStorage.getItem('relasit-product-id') || null;
                const key = currentProductId || 'default';
                const savedQuantity = shrine.quantityBreaksSync.savedSelections.get(key);
                
                if (savedQuantity) {
                  hasAppliedSelection = true;
                  // Esperar un poco más para que ReLasit termine de cargar completamente
                  setTimeout(() => {
                    shrine.quantityBreaksSync.applySavedSelectionToRelasitModal(currentProductId, savedQuantity, 0);
                  }, 500);
                }
              }
            } else {
              // Resetear bandera cuando el modal se cierra
              hasAppliedSelection = false;
            }
          }, 300);
        });
        
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class', 'aria-hidden']
        });
        
        // También escuchar clics en el botón de ReLasit para aplicar selección cuando se abre
        document.addEventListener('click', function(e) {
          const target = e.target;
          if (target.closest && (
            target.closest('[id*="releasit"], [id*="relasit"]') ||
            target.closest('._rsi-buy-now-button, [class*="rsi-buy-now"]')
          )) {
            // Resetear bandera cuando se hace clic en el botón
            hasAppliedSelection = false;
            
            // Esperar a que se abra el modal y aplicar selección
            setTimeout(() => {
              const currentProductId = localStorage.getItem('relasit-product-id') || null;
              const key = currentProductId || 'default';
              const savedQuantity = shrine.quantityBreaksSync.savedSelections.get(key);
              
              if (savedQuantity) {
                setTimeout(() => {
                  shrine.quantityBreaksSync.applySavedSelectionToRelasitModal(currentProductId, savedQuantity, 0);
                }, 800); // Esperar más tiempo después del clic del botón
              }
            }, 100);
          }
        }, true);
        
        // Escuchar clics en ofertas de ReLasit para sincronizar hacia Quality y limpiar estilos
        document.addEventListener('click', function(e) {
          const target = e.target;
          
          // Detectar cuando el usuario hace clic manualmente en una oferta de ReLasit
          const relasitOffer = target.closest('._rsi-quantity-offers-offer-container');
          if (relasitOffer) {
            // Esperar un momento para que ReLasit procese el clic
            setTimeout(() => {
              // Limpiar TODAS las otras ofertas para que queden con CSS normal
              const allOffers = document.querySelectorAll('._rsi-quantity-offers-offer-container');
              allOffers.forEach(offer => {
                if (offer !== relasitOffer) {
                  // Remover TODAS las clases de selección
                  offer.classList.remove('_rsi-quantity-offers-selected', 'selected', 'active', '_rsi-selected');
                  offer.removeAttribute('data-selected');
                  offer.removeAttribute('aria-selected');
                  
                  // Remover TODOS los estilos inline para que quede con CSS normal
                  offer.style.removeProperty('border-color');
                  offer.style.removeProperty('border');
                  offer.style.removeProperty('border-width');
                  offer.style.removeProperty('border-style');
                  offer.style.removeProperty('background-color');
                  offer.style.removeProperty('background');
                  
                  // Si el atributo style está vacío, removerlo completamente
                  const remainingStyles = offer.style.cssText.trim();
                  if (!remainingStyles || remainingStyles === '') {
                    offer.removeAttribute('style');
                  } else {
                    // Si hay otros estilos, filtrar y remover solo los relacionados con selección
                    offer.style.cssText = remainingStyles
                      .split(';')
                      .filter(style => {
                        const prop = style.split(':')[0].trim().toLowerCase();
                        return !prop.includes('border') && !prop.includes('background');
                      })
                      .join(';');
                    
                    // Si quedó vacío después del filtro, remover el atributo
                    if (!offer.style.cssText.trim()) {
                      offer.removeAttribute('style');
                    }
                  }
                  
                  // Desmarcar inputs dentro de otras ofertas
                  const otherInputs = offer.querySelectorAll('input[type="radio"], input[type="checkbox"]');
                  otherInputs.forEach(input => {
                    input.checked = false;
                  });
                }
              });
              
              // SINCRONIZAR desde ReLasit hacia Quality cuando el usuario selecciona manualmente
              const selectedTitle = relasitOffer.querySelector('._rsi-quantity-offers-title');
              if (selectedTitle) {
                const selectedText = selectedTitle.textContent || '';
                const selectedQuantity = shrine.quantityBreaksSync.extractQuantityFromText(selectedText);
                if (selectedQuantity) {
                  // Actualizar Quality para que coincida con la selección de ReLasit
                  const quantityBreaksElement = document.querySelector('quantity-breaks[id^="quantity-breaks-"]');
                  if (quantityBreaksElement) {
                    const matchingInput = quantityBreaksElement.querySelector(`input[type="radio"][name="quantity"][value="${selectedQuantity}"]`);
                    if (matchingInput && !matchingInput.checked) {
                      matchingInput.checked = true;
                      matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                  }
                }
              }
            }, 150); // Esperar 150ms para que ReLasit procese el clic primero
          }
        }, true);
      }
    };
    
    // Inicializar cuando el DOM esté listo
    function initQuantityBreaksSync() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          shrine.quantityBreaksSync.init();
        });
      } else {
        shrine.quantityBreaksSync.init();
      }
    }
    
    // Inicializar inmediatamente si el script se carga después del DOM
    initQuantityBreaksSync();
    
    // También inicializar cuando Shopify carga secciones dinámicamente
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        const quantityBreaksElements = event.target.querySelectorAll('quantity-breaks[id^="quantity-breaks-"]');
        quantityBreaksElements.forEach(element => {
          shrine.quantityBreaksSync.initQuantityBreaks(element);
        });
      });
    }
    
    
  })();